// Cart drawer "Others also bought" Add buttons (snippets/cart-upsell.liquid). Loaded with the drawer on every page:
// a script inside the drawer markup would arrive by morph and never run.
import { CartLinesUpdateEvent } from '@shopify/events';
if (!window.__cartUpsell) {
  window.__cartUpsell = true;
  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-cu-step]');
    if (step) {   // arrows: one card per click
      const list = step.closest('.cart-upsell').querySelector('.cu-list');
      list.scrollBy({ left: Number(step.dataset.cuStep) * (list.firstElementChild.offsetWidth + 6), behavior: 'smooth' });
      return;
    }
    const btn = e.target.closest('[data-cart-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.closest('.cu-card').querySelector('select, input').value;
    btn.disabled = true; btn.textContent = '…';
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    // Same event the product form sends, so the drawer morphs in the new sections
    btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise }));
    try {
      const r = await fetch(Theme.routes.cart_add_url, {   // already /cart/add.js
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(','), sections_url: location.pathname }),
      });
      const added = await r.json();
      const cart = await (await fetch(Theme.routes.cart_url + '.js')).json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections: added.sections, items: cart.items, itemCount: 1, source: 'cart-upsell', didError: !r.ok },
      });
      if (!r.ok) { btn.disabled = false; btn.textContent = '+ Add'; }
    } catch (err) {
      deferred.reject(err); btn.disabled = false; btn.textContent = '+ Add';
    }
  });
}
